export enum PlasticsReworkStatus {
    InProgress = 'In Progress',
    Complete = 'Complete',
}

export interface PlasticsRework {
    id: string;
    customerId: string;
    complaintLogId: string;
    productId: string;
    quantity: number;
    status: PlasticsReworkStatus;
    returnedOn: Date | null;
    reworkedOn: Date | null;
    notes: string;
    reworkProcedureId: string;
    createdOn: Date;
    createdById: string;
    updatedOn: Date;
    updatedById: string;
}

export interface EditPlasticsReworkDialogArgs {
    rework: PlasticsRework | null;
}

export interface EditPlasticsReworkDialogReturnValue {
    rework: PlasticsRework;
}
